module.exports = __webpack_public_path__ + "img/desktop.4fff6521.webp";